import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-actionwithcheckbox',
    template: `
      <!-- VIEW BUTTON (NEW) -->
 <button *ngIf="params.view"
        title="View"
        (click)="view($event)"
        class="btn btn-outline btn-info btn-rounded btn-sm waves-effect waves-light"
        style="padding: .3rem .8rem; margin-top: 0rem;">
  <i class="fas fa-eye"></i>
</button>

    <button title="Edit" (click)="edit($event)" 
            class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light" 
            style="padding: .3rem .8rem; margin-top: 0rem;" 
            [disabled]="!hasPermission(128)">
      <i class="fas fa-pencil-alt"></i>
    </button>

   

   <button title="Delete"  class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="padding: .3rem .8rem;margin-top:0rem;background:#d71920" 
  [appCriticalOperation]="129"
  [criticalMethod]="delete.bind(this)">
    <i class="far fa-trash-alt"></i>
  </button>

    
       <input
       *ngIf="params?.onCheckboxChange"
  type="checkbox"
  [checked]="params.node.data.isSelected"
  (change)="onCheckboxChange($event)"
  style="margin-left: 7px; margin-right: 6px; transform: scale(1.2); background:#F4C430"
/>




    
  `,
    standalone: false
})
export class ActionwithcheckboxComponent implements ICellRendererAngularComp {
  params: any;
  selectInstance: boolean = false;
   permissions: any[] = [];

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.selectInstance = params.data?.selectinstance ?? false;
     this.permissions = this.params.values || [];
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  edit($event) {
    console.log("----------------")
    console.log($event)
    console.log("-------------------")
    if (this.params.edit instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.edit(params);

    }
  }
  delete($event) {
    if (this.params.delete instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.delete(params);

    }
  }

  

  // hasPermission(code: number): boolean {
  //   // Replace this with real permission logic
  //   return true;
  // }
  hasPermission(buttonId: number): boolean {
    // Check if 'screen' exists in the permissions array
    const hasScreen = this.permissions.some(permission =>
        typeof permission === 'string' && permission.includes('screen')
    );

    // If 'screen' is not present, enable all buttons
    if (!hasScreen) {
        return true;
    }

    // Otherwise, check if the specific buttonId is in the permissions list
    return this.permissions.includes(buttonId);
   }

  onCheckboxChange(event: any) {
        const checked = event.target.checked;
      
        if (this.params?.node?.data) {
          this.params.node.data.isSelected = checked;
      
          if (this.params.onCheckboxChange instanceof Function) {
            if (this.params.onCheckboxChange instanceof Function) {
                this.params.onCheckboxChange({
                  checked: checked,
                  rowData: this.params.node.data  // ✅ always send rowData
                });
              }
          }
        } else {
          console.error('params.node.data is undefined');
        }
      }


      view($event) {
  // If parent has view function → call it
  if (this.params.view instanceof Function) {
    this.params.view({
      event: $event,
      rowData: this.params.node.data
    });
  } else {
    // NO backend / NO parent → just log (safe fallback)
    console.log("VIEW CLICKED", this.params.node.data);
  }
}

}
